export class NoteModel {
    constructor(data) {
        if (data) {
            this.noteId = data.noteId ?? null;
            this.parentType = data.parentType ?? null;          // e.g., 'document', 'appeal'
            this.parentId = data.parentId ?? null;              // parent object ID
            this.parentVersion = data.parentVersion ?? null;    // optional version
            this.createdBy = data.createdBy ?? null;            // user ID of creator
            this.createdByUser = data.createdByUser ?? null;
            this.note = data.note ?? null;                      // note text
            this.createdAt = data.createdAt ?? null;
            this.updatedAt = data.updatedAt ?? null;
        }
    }
}
